import { useEffect, useRef, useState } from 'react';
import jsQR from 'jsqr';
import { extractQrToken, markQrScan } from '../lib/attendance';

// Escáner dentro de la app: abre la cámara, lee el QR de la pantalla del local y registra.
export default function QrScanModal({ open, onClose, cfg, onDone }) {
  const videoRef = useRef(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState('Apuntá al código QR de la pantalla');

  useEffect(() => {
    if (!open) return undefined;
    let stream; let raf; let stopped = false; let handled = false;
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    setErr(''); setBusy(false); setStatus('Apuntá al código QR de la pantalla');

    const tick = () => {
      if (stopped) return;
      const v = videoRef.current;
      if (v && v.readyState === v.HAVE_ENOUGH_DATA && !handled) {
        canvas.width = v.videoWidth; canvas.height = v.videoHeight;
        ctx.drawImage(v, 0, 0, canvas.width, canvas.height);
        const img = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(img.data, img.width, img.height, { inversionAttempts: 'dontInvert' });
        const token = code ? extractQrToken(code.data) : null;
        if (code && !token) setStatus('Ese QR no es de registro de asistencia');
        if (token) {
          handled = true; setBusy(true); setStatus('Registrando…');
          markQrScan(token, cfg).then((r) => { onDone(r); onClose(); })
            .catch((e) => { setErr(e.message || 'No se pudo registrar'); setBusy(false); handled = false; setTimeout(() => { if (!stopped) { setErr(''); setStatus('Apuntá al código QR de la pantalla'); } }, 4000); });
        }
      }
      raf = requestAnimationFrame(tick);
    };

    navigator.mediaDevices?.getUserMedia({ video: { facingMode: 'environment' }, audio: false })
      .then((s) => { if (stopped) { s.getTracks().forEach((t) => t.stop()); return; } stream = s; videoRef.current.srcObject = s; videoRef.current.play().catch(() => {}); raf = requestAnimationFrame(tick); })
      .catch(() => setErr('No pudimos abrir la cámara. Permití el acceso, o escaneá el QR con la cámara del celular.'));

    return () => { stopped = true; cancelAnimationFrame(raf); stream?.getTracks().forEach((t) => t.stop()); };
  }, [open, cfg, onClose, onDone]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center">
      <div className="absolute inset-0 bg-black/70" onClick={() => !busy && onClose()} />
      <div className="relative bg-white w-full max-w-sm rounded-t-3xl sm:rounded-3xl shadow-2xl p-5 text-center">
        <h2 className="font-bold text-gray-900 text-lg">Escanear QR</h2>
        <div className="relative mt-3 rounded-2xl overflow-hidden bg-black aspect-square">
          <video ref={videoRef} playsInline muted className="w-full h-full object-cover" />
          <div className="absolute inset-8 border-2 border-white/80 rounded-2xl pointer-events-none" />
        </div>
        <p className={`text-sm mt-3 ${err ? 'text-red-600' : 'text-gray-500'}`}>{err || status}</p>
        <button onClick={onClose} disabled={busy} className="mt-3 text-sm text-gray-400 hover:text-gray-600 disabled:opacity-40">Cancelar</button>
      </div>
    </div>
  );
}
